<ng-container infiniteScroll [infiniteScrollDistance]="0.5" [infiniteScrollContainer]="'.main-view'"
    [infiniteScrollThrottle]="50" [fromRoot]="true" (scrolled)="onOeqScroll()">

    <!-- Empty State Message -->
    <div class="empty-state-container" *ngIf="!oeqsInfo?.questions || oeqsInfo?.questions?.length === 0">
        <div class="empty-state-content">
            <div class="empty-state-icon">
                <mat-icon>edit_note</mat-icon>
            </div>
            <h3 class="empty-state-title">No Open Ended Questions Available</h3>
            <p class="empty-state-description">
                No open ended questions found for the selected criteria.
                Try adjusting your filters or generate new questions.
            </p>
        </div>
    </div>

    <div class="mcq-card" *ngFor="let item of oeqsInfo?.questions; let i = index"
        [class.flash-highlight]="item._highlight">
        <div class="undo-section" *ngIf="item.selected && !(item.displayText?.length || item.error)">
            <app-undo class="undo-comp" [undoItem]="undoSelectedItem"
                (undoAction)="undoSelectedIQuestion(item)"></app-undo>
        </div>

        <div class="mcq-header">
            <div class="mcq-header-left">
                <mat-checkbox class="mcq-select-checkbox" [checked]="item._selected"
                    (change)="onSelectChange(item, $event)" (click)="$event.stopPropagation()"
                    [disabled]="item.selected" *ngIf="showCheckboxes" color="primary"></mat-checkbox>
                <div class="question-identity">
                    <span class="q-label">Q{{i+1}}</span>
                </div>
                <span class="difficulty-chip" [ngClass]="item.difficultyLevel?.toLowerCase() || 'medium'">
                    <mat-icon class="difficulty-icon">signal_cellular_alt</mat-icon>
                    {{ item.difficultyLevel | difficultyLevel }}
                </span>

                <button mat-icon-button [matMenuTriggerFor]="oeqMenu" class="more-actions-btn"
                    *ngIf="!item.regenerate && !item.selected && !oeqsInfo?.isPreview && (oeqsInfo?.from === 'questionsList' || oeqsInfo?.category === 'GENERATED' || oeqsInfo?.category === 'PREVIOUSLYGENERATED' || oeqsInfo?.category === 'SELECTED' || oeqsInfo?.from === 'selected')"
                    (click)="setMenuItem(item); $event.stopPropagation()">
                    <mat-icon>more_horiz</mat-icon>
                </button>
            </div>

            <div class="mcq-header-right">
                <button mat-button class="select-btn"
                    *ngIf="oeqsInfo?.category === 'GENERATED' || oeqsInfo?.category === 'PREVIOUSLYGENERATED'"
                    (click)="$event.stopPropagation();addOeqToAssessment(item);"
                    [disabled]="item.regenerate || item.selected" [ngClass]="{'is-selected': item.selected}">
                    <mat-icon>{{ item.selected ? 'check' : 'add' }}</mat-icon>
                    {{ item.selected ? 'Selected' : 'Select' }}
                </button>

                <button mat-button class="remove-btn" *ngIf="oeqsInfo?.category === 'SELECTED'"
                    (click)="$event.stopPropagation(); removeSelectedOEQ.emit(item);">
                    <mat-icon>remove_circle_outline</mat-icon>
                    Remove
                </button>

                <button mat-icon-button class="expand-btn" (click)="item.expanded = !item.expanded"
                    [disabled]="item.regenerate || item.selected">
                    <mat-icon class="expand-icon" [class.is-expanded]="item.expanded">expand_more</mat-icon>
                </button>
            </div>
        </div>

        <div class="mcq-body"
            [ngClass]="{'dimmed': item.selected && !(item.displayText?.length || item.error), 'regenerate-center': item.regenerate}">
            <ng-container *ngIf="item.regenerate; else normalContent">
                <app-generate-loader [displayText]="displayText" [genearateSuccess]="genearateSuccess"
                    [reGenerate]="true"></app-generate-loader>
            </ng-container>

            <ng-template #normalContent>
                <div class="insight-board">
                    <!-- Global Edit Button (only if not editing) -->
                    <div class="section-label-row no-border" *ngIf="!item.edit_clicked">
                        <div class="section-label">
                            <mat-icon class="section-icon">description</mat-icon>
                            <span>Question Details</span>
                        </div>
                        <div class="section-actions">
                            <button mat-icon-button class="edit-btn"
                                *ngIf="oeqsInfo.from !== 'preview' && !oeqsInfo.isPreview" (click)="onEditClick(item)">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                    </div>


                    <div class="question-text-container">
                        <ng-container *ngIf="!item?.edit_clicked; else questionEditor">
                            <div class="question-text" [innerHTML]="formatQuestionText(item.questionText)"></div>
                        </ng-container>
                        <ng-template #questionEditor>
                            <div class="edit-question-block inplace">
                                <angular-editor class="edit-question-textarea" (click)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                                    [(ngModel)]="item.temp_questionText" [config]="editorEditConfig" id="q-text-{{i}}">
                                </angular-editor>
                            </div>
                        </ng-template>
                    </div>

                    <!-- Answer Section (Expanded Only) -->
                    <div class="oeq-answer-section" *ngIf="item.expanded">
                        <div class="section-label-row" *ngIf="item.edit_clicked">
                            <div class="section-label">
                                <mat-icon class="section-icon">verified_user</mat-icon>
                                <span>House Answer</span>
                            </div>
                        </div>

                        <div class="answer-content-container">
                            <ng-container *ngIf="!item?.edit_clicked; else answerEditor">
                                <div class="oeq-answer-content" [innerHTML]="formatQuestionText(item.answer)"></div>
                            </ng-container>
                            <ng-template #answerEditor>
                                <div class="edit-question-block inplace">
                                    <angular-editor class="edit-answer-textarea" (click)="$event.stopPropagation()"
                                        (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                                        [(ngModel)]="item.temp_answer" [config]="editorEditConfig" id="ans-text-{{i}}">
                                    </angular-editor>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div class="tags-container" *ngIf="!item.edit_clicked">
                        <div class="subtopics-list" *ngIf="item.subTopics?.length">
                            <span class="tag-badge subtopic" *ngFor="let topic of item.subTopics">
                                <mat-icon>folder</mat-icon>
                                {{ topic.name }}
                            </span>
                        </div>
                        <div class="topics-list" *ngIf="!item.subTopics?.length && item.topics?.length">
                            <span class="tag-badge topic" *ngFor="let topic of item.topics">
                                <mat-icon>tag</mat-icon>
                                {{ topic.topic }}
                            </span>
                        </div>
                    </div>

                    <!-- Integrated Bottom Right Actions -->
                    <div class="edit-footer-actions" *ngIf="item.edit_clicked">
                        <button mat-button class="cancel-btn" (click)="onEditCancelBtnClick(item)">Cancel</button>
                        <button mat-flat-button class="save-btn" color="primary"
                            (click)="onEditDone(item)">Save</button>
                    </div>
                </div>

            </ng-template>
        </div>
    </div>

    <mat-menu #oeqMenu="matMenu">
        <button mat-menu-item *ngIf="oeqsInfo?.category === 'SELECTED'"
            (click)="$event.stopPropagation(); onEditClick(menuItem)">
            <mat-icon>edit</mat-icon> Edit
        </button>
        <button mat-menu-item *ngIf="oeqsInfo?.category !== 'SELECTED'"
            (click)="$event.stopPropagation(); onEditClick(menuItem)">
            <mat-icon>edit</mat-icon> Edit
        </button>
        <button mat-menu-item *ngIf="oeqsInfo?.category !== 'SELECTED'"
            (click)="$event.stopPropagation(); onDuplicate(menuItem)">
            <mat-icon>content_copy</mat-icon> Duplicate
        </button>
        <button mat-menu-item *ngIf="oeqsInfo?.category !== 'SELECTED'"
            (click)="$event.stopPropagation(); confirmDeleteSelected(menuItem)">
            <mat-icon>delete</mat-icon> Delete
        </button>
        <button mat-menu-item *ngIf="oeqsInfo?.category === 'GENERATED'"
            (click)="$event.stopPropagation(); openRegenerateDialog(menuItem)">
            <mat-icon>autorenew</mat-icon> Regenerate
        </button>
    </mat-menu>
</ng-container>